import { QueryClient } from '@tanstack/react-query';
import { queryClientDisposeOnCacheEvict } from './queryClientDisposeOnCacheEvict';

export function createStandardQueryClient() {
  const client = new QueryClient();
  queryClientDisposeOnCacheEvict(client);
  return client;
}
